(function () {
    'use strict';

    angular.module('l4b')
        .controller('EmailVerificationController', EmailVerificationController);

    EmailVerificationController.$inject = ['FlowService', 'StorageService', 'BrandService', 'Constants', 'RestService', 'GlobalizationService', '$cookies', '$interval', '$scope', '$stateParams', 'DTOFactory', 'Utils', '$window', '$timeout'];

    function EmailVerificationController(FlowService, StorageService, BrandService, Constants, RestService, GlobalizationService, $cookies, $interval, $scope, $stateParams, DTOFactory, Utils, $window, $timeout) {

        var vm = this,
			emailForm = null,
			verificationForm = null,
			interval = null,
			remainingMs = null;
   
        angular.extend(vm, {
            $onInit: init,
            nextStep: nextStep,
            updateEmail: updateEmail,
            back: back,
            pii: DTOFactory.Application().Applicant,
            noreplyEmail: StorageService.get(Constants.SK.NoreplyEmail) || 'noreply@verizon.com',
            onVerificationCodeChanged: onVerificationCodeChanged,
            resend: resend,
            verificationCode: '',
			brand:  BrandService.getCurrent().Name,
            patterns: { 
				verificationCode: /^[0-9]{6}$/,
				email: Constants.Pattern.EMAIL
			},
            allowResend: allowResend,
            timeFormat: timeFormat,
			showCodeResent: false,
			showEmail: false,
			emailUpdated: false,
			toggleEmail: toggleEmail,
			onEmailChanged: onEmailChanged,
			maxLengths: Constants.LengthRestrictions
        });

        function init() {
            RestService.createPin(createOrResendSuccess, onError);
        }

        function back() {
            FlowService.goToPersonalInformation();
        }

        function nextStep(_emailForm, _verificationForm) {
            if (!Utils.validateForm(_verificationForm)) {
                return;
            }

			emailForm = emailForm || _emailForm;
			verificationForm = verificationForm || _verificationForm;

            RestService.validatePin(vm.verificationCode, onVerifyCodeSuccess, onError);
        }

        function updateEmail(_emailForm, _verificationForm) {
            if (!Utils.validateForm(_emailForm)) {
                return;
            }
			
			emailForm = emailForm || _emailForm;
			verificationForm = verificationForm || _verificationForm;

			if (vm.pii.Email == vm.updatedEmail) {
				emailForm.email.$setValidity('equals', false);
				return;
			}
			
			var payload = {
				Email: vm.updatedEmail
			};
			
            RestService.changeEmail(payload, onChangedEmailSuccess, onError);
        }
		
		function onChangedEmailSuccess() {
			vm.pii.Email = vm.updatedEmail;
			vm.emailUpdated = true;

			StorageService.set(Constants.SK.Applicant, vm.pii);

			RestService.createPin(resendSuccess, onError);

			$window.scrollTo({ top: 0, behavior: "smooth" });
		}
		
		function clearEmailForm() {
			vm.updatedEmail = '';
			
			vm.showEmail = false;
			
			onEmailChanged();
		}
		
		function clearVerificationForm() {
			vm.verificationCode = '';
			
			onVerificationCodeChanged();
		}
		
		function onVerifyCodeSuccess() {
			FlowService.nextStep();
		}

		function onError(data) {
			var code = data && data.data
				? data.data.code
				: null;
				
			onEmailChanged();
			onVerificationCodeChanged();

			if (code == Constants.Error.EMAIL_BELONG_AGENT && emailForm && emailForm.email) {
				emailForm.email.$setValidity('invalidEmail', false);
				return;
			}
			else if (code == Constants.Error.EMAIL_DOMAIN_NOT_ALLOWED && emailForm && emailForm.email) {
				emailForm.email.$setValidity('invalidDomain', false);
				return;
			}
			else if (code == Constants.Error.EMAILS_ARE_EQUAL && emailForm && emailForm.email) {
				emailForm.email.$setValidity('equals', false);
				return;
			}
			else if (code == Constants.Error.INVALID_EMAILVALIDATION && verificationForm && verificationForm.verificationCode) {
				verificationForm.verificationCode.$setValidity('invalidcode', false);
				return;
			}

			StorageService.set(Constants.SK.Error, code);
			FlowService.goToExit();
		}

		function onVerificationCodeChanged() {
			if (!verificationForm || !verificationForm.verificationCode) {
				return;
			}

			verificationForm.verificationCode.$setValidity('invalidcode', true);
			verificationForm.verificationCode.$setValidity('required', true);
		}

		function onEmailChanged() {
			if (!emailForm || !emailForm.email) {
				return;
			}

			emailForm.email.$setValidity('invalidEmail', true);
			emailForm.email.$setValidity('invalidDomain', true);
			emailForm.email.$setValidity('equals', true);
		}

        function resend() {
            RestService.resendPin(resendSuccess, onError);
        }

		function resendSuccess(response) {
			vm.showCodeResent = true;
			$timeout(function() {
				vm.showCodeResent = false;
			}, 3000);
			
			createOrResendSuccess(response);
		}
		
		function createOrResendSuccess(response) {
			
			if (interval) {
				$interval.cancel(interval);				
			}
			
			clearEmailForm();
			clearVerificationForm();

			remainingMs = response.data.availableRefreshSeconds * 1000;

			initTimer();
		}

		function allowResend() {
			return remainingMs <= 0;
		}

        function initTimer() {
            interval = $interval(function () {
                if (remainingMs <= 0) {
                    $interval.cancel(interval);
					return;
                }

				remainingMs -= 1000;
            }, 1000);
        }

        function timeFormat() {
			if (!remainingMs) {
				return;
			}

			var totalSeconds = Math.floor(remainingMs / 1000);
			var minutes = Math.floor(totalSeconds / 60);
			var seconds = totalSeconds % 60;

			return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
        }

        function toggleEmail() {
			vm.showEmail = !vm.showEmail;
			if (vm.showEmail) {
				vm.emailUpdated = false;
			}
        }
    }
})();
